import { render, staticRenderFns } from "./folder_settings.vue?vue&type=template&id=45be1531&scoped=true&"
import script from "./folder_settings.vue?vue&type=script&lang=js&"
export * from "./folder_settings.vue?vue&type=script&lang=js&"
import style0 from "./folder_settings.vue?vue&type=style&index=0&id=45be1531&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be1531",
  null
  
)

export default component.exports